import "./common.js";
import {bubbleDescribeNoticeWithInSelf} from "@/components/common/controlBar/utils.js";
import {noBusinessNodes} from "@/components/common/controlBar/controlBarDialog/const.js";

function getDomOfNode(node) {
  var dom = document.querySelector(`.${node.id}`)
  return dom
}

export function isMethodsNode(node){
  // return actionsMapOfComponents[node.componentName]
  return true
}

export function getClosestMethodDom(node){
  var closestMethodNode = getClosestMethodNode(node)
  if(closestMethodNode){
    var closestMethodDom = getDomOfNode(closestMethodNode)
    return closestMethodDom
  }else{
    return null
  }

}

export function getClosestMethodNode(node){
  var res
  bubbleDescribeNoticeWithInSelf(node, (noticeNode) => {
    if(
      (!noBusinessNodes.includes(noticeNode.componentName) && !noticeNode?.disabled) ||
      mm.utils.checkCol(noticeNode)
    ){
      if(isMethodsNode(noticeNode) && !res){
        res = noticeNode
      }
    }
  })
  return res
}

export function clearHightLightMethodDom(){
  document.querySelectorAll('.targetOfCatcher').forEach((dom)=>{
    dom.classList.remove('targetOfCatcher')
  })
}

export function highLightClosestMethodNode(node){
  clearHightLightMethodDom()

  var matchedDom = getClosestMethodDom(node)
  if(matchedDom){
    matchedDom.classList.add('targetOfCatcher')
  }
}


export function isEnableCatching(){
  var node = mm.store.state.catchNode
  return node && node.hasOwnProperty('indexOfCatching') && node.indexOfCatching !== -1
}

export function unableCatching(node){
  node.indexOfCatching = -1

  clearHightLightMethodDom()
}





export function getActionParams(actionId) {
  var match = self.actionListOfReanod.find((action) => {
    return action.id === actionId
  })
  if (match) {
    return match.params
  } else {
    return null
  }
}



export function getActionsOfNode(node) {
  if (node && isMethodsNode(node)) {
    if(actionsMapOfComponents[node.componentName]){
      return actionsMapOfComponents[node.componentName]
    }else{
      return self.actionListOfReanod.filter((action) => {
        var arr = [...commonActionIds]
        return arr.includes(action.id)
      })
    }

  } else {
    return []
  }
}

const commonActionIds = ['show','hide']
export const actionsMapOfComponents = {
  list_product: self.actionListOfReanod.filter((action) => {
    var arr = [...commonActionIds, 'filter']
    return arr.includes(action.id)
  }),
  button_text: self.actionListOfReanod.filter((action) => {
    var arr = [...commonActionIds]
    return arr.includes(action.id)
  })
}
